import { useCallback } from 'react';
import { dashboardRoute } from '../../helpers/apiRoutes';
import { useApiCalls } from '../UseApiCalls';

export const DashboardApis = () => {
  const { getQuery } = useApiCalls();

  const getUserAverageTat = useCallback(() => {
    return getQuery(`${dashboardRoute}/get-user-average-tat`);
  }, [getQuery]);

  const getUserOnTimeReporting = useCallback(() => {
    return getQuery(`${dashboardRoute}/get-user-ontime-reporting`);
  }, [getQuery]);

  const getUserSamplesSubmitted = useCallback(() => {
    return getQuery(`${dashboardRoute}/get-user-samples-submitted`);
  }, [getQuery]);

  const getUserInProgressSamples = useCallback(() => {
    return getQuery(`${dashboardRoute}/get-user-in-progress-samples`);
  }, [getQuery]);

  const getUserTotalSpend = useCallback(() => {
    return getQuery(`${dashboardRoute}/get-user-spend`);
  }, [getQuery]);

  const getClientAverageTat = useCallback((client: string, limsDatabase: string) => {
    return getQuery(`${dashboardRoute}/get-client-average-tat?client=${encodeURIComponent(client)}&limsDatabase=${encodeURIComponent(limsDatabase)}`);
  }, [getQuery]);

  const getClientOnTimeReporting = useCallback((client: string, limsDatabase: string) => {
    return getQuery(`${dashboardRoute}/get-client-ontime-reporting?client=${encodeURIComponent(client)}&limsDatabase=${encodeURIComponent(limsDatabase)}`);
  }, [getQuery]);

  const getClientSamplesSubmitted = useCallback((client: string, limsDatabase: string) => {
    return getQuery(`${dashboardRoute}/get-client-samples-submitted?client=${encodeURIComponent(client)}&limsDatabase=${encodeURIComponent(limsDatabase)}`);
  }, [getQuery]);

  const getClientInProgressSamples = useCallback((client: string, limsDatabase: string) => {
    return getQuery(`${dashboardRoute}/get-client-in-progress-samples?client=${encodeURIComponent(client)}&limsDatabase=${encodeURIComponent(limsDatabase)}`);
  }, [getQuery]);

  const getClientTotalSpend = useCallback((client: string, limsDatabase: string) => {
    return getQuery(`${dashboardRoute}/get-client-spend?client=${encodeURIComponent(client)}&limsDatabase=${encodeURIComponent(limsDatabase)}`);
  }, [getQuery]);

  const getAllDashboardClients = useCallback(() => {
    return getQuery(`${dashboardRoute}/get-all-dashboard-clients`);
  }, [getQuery]);

  return {
    getUserAverageTat,
    getUserOnTimeReporting,
    getUserSamplesSubmitted,
    getUserInProgressSamples,
    getUserTotalSpend,
    getClientAverageTat,
    getClientOnTimeReporting,
    getClientSamplesSubmitted,
    getClientInProgressSamples,
    getClientTotalSpend,
    getAllDashboardClients
  };
};
